import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, CheckCircle, Building2 } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { profileData } from '../data/mockData';
export function BankDetails() {
  const navigate = useNavigate();
  const [showSuccess, setShowSuccess] = useState(false);
  const [formData, setFormData] = useState({
    bankName: profileData.bankDetails.bankName,
    accountNumber: profileData.bankDetails.accountNumber,
    accountName: profileData.bankDetails.accountName
  });
  const [isVerifying, setIsVerifying] = useState(false);
  const banks = ['GTBank', 'Access Bank', 'First Bank', 'UBA', 'Zenith Bank', 'Stanbic IBTC', 'Kuda MFB', 'OPay'];
  const handleAccountNumberChange = (value: string) => {
    setFormData({
      ...formData,
      accountNumber: value,
      accountName: ''
    });
    if (value.length === 10) {
      setIsVerifying(true);
      setTimeout(() => {
        setFormData(prev => ({
          ...prev,
          accountName: 'Adebayo Johnson'
        }));
        setIsVerifying(false);
      }, 1500);
    }
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setShowSuccess(true);
    setTimeout(() => {
      navigate('/profile');
    }, 2000);
  };
  return <div className="min-h-screen" data-id="element-92">
      <div className="max-w-md mx-auto" data-id="element-93">
        {/* Header */}
        <div className="flex items-center gap-4 p-5 pt-8" data-id="element-94">
          <button onClick={() => navigate('/profile')} className="w-10 h-10 rounded-full glass-card flex items-center justify-center text-white hover:bg-white/[0.08] transition-colors" data-id="element-95">
            <ArrowLeft className="w-5 h-5" data-id="element-96" />
          </button>
          <h1 className="text-white text-2xl font-bold tracking-tight" data-id="element-97">
            Bank Details
          </h1>
        </div>

        <form onSubmit={handleSubmit} className="px-5 space-y-5 pb-10" data-id="element-98">
          {/* Current Linked Bank */}
          {profileData.bankDetails.isLinked && <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="bg-[#00D68F]/[0.06] border border-[#00D68F]/20 rounded-2xl p-5" data-id="element-99">
              <div className="flex items-center gap-3 mb-3" data-id="element-100">
                <div className="w-10 h-10 rounded-full bg-[#00D68F]/10 flex items-center justify-center" data-id="element-101">
                  <Building2 className="w-5 h-5 text-[#00D68F]" data-id="element-102" />
                </div>
                <div data-id="element-103">
                  <p className="text-[#00D68F] font-bold tracking-tight text-sm" data-id="element-104">
                    Bank Linked ✓
                  </p>
                  <p className="text-[#00D68F]/70 text-xs" data-id="element-105">Currently active</p>
                </div>
              </div>
              <div className="space-y-1 pl-[52px]" data-id="element-106">
                <p className="text-white font-bold tracking-tight" data-id="element-107">
                  {profileData.bankDetails.bankName}
                </p>
                <p className="text-[#64748B] font-mono text-sm" data-id="element-108">
                  {profileData.bankDetails.accountNumber}
                </p>
                <p className="text-[#64748B] text-sm" data-id="element-109">
                  {profileData.bankDetails.accountName}
                </p>
              </div>
            </motion.div>}

          <div className="glass-card p-5 space-y-5" data-id="element-110">
            <p className="text-label" data-id="element-111">Update Bank Details</p>

            <div data-id="element-112">
              <label className="text-label mb-2 block" data-id="element-113">Bank Name</label>
              <select value={formData.bankName} onChange={e => setFormData({
              ...formData,
              bankName: e.target.value
            })} className="w-full glass-input px-4 py-3.5 appearance-none" data-id="element-114">
                {banks.map(bank => <option key={bank} value={bank} className="bg-[#0A0E1A]" data-id="element-115">
                    {bank}
                  </option>)}
              </select>
            </div>

            <div data-id="element-116">
              <label className="text-label mb-2 block" data-id="element-117">Account Number</label>
              <input type="text" value={formData.accountNumber} onChange={e => handleAccountNumberChange(e.target.value)} placeholder="0123456789" required maxLength={10} className="w-full glass-input px-4 py-3.5 placeholder-[#475569] font-mono tracking-widest" data-id="element-118" />
            </div>

            <div data-id="element-119">
              <label className="text-label mb-2 block" data-id="element-120">Account Name</label>
              <div className="w-full glass-input px-4 py-3.5 min-h-[52px] flex items-center" data-id="element-121">
                {isVerifying ? <div className="flex items-center gap-2" data-id="element-122">
                    <div className="w-4 h-4 border-2 border-[#00D68F] border-t-transparent rounded-full animate-spin" data-id="element-123" />
                    <span className="text-[#64748B] text-sm" data-id="element-124">
                      Verifying account...
                    </span>
                  </div> : formData.accountName ? <div className="flex items-center gap-2" data-id="element-125">
                    <CheckCircle className="w-4 h-4 text-[#00D68F]" data-id="element-126" />
                    <span className="text-white font-medium" data-id="element-127">
                      {formData.accountName}
                    </span>
                  </div> : <span className="text-[#475569]" data-id="element-128">
                    Auto-filled after verification
                  </span>}
              </div>
            </div>
          </div>

          <motion.button whileTap={{
          scale: 0.97
        }} type="submit" disabled={!formData.accountName} className="w-full bg-[#00D68F] text-[#0A0E1A] rounded-2xl py-4 font-bold text-lg shadow-[0_0_20px_rgba(0,214,143,0.2)] disabled:opacity-40 disabled:cursor-not-allowed" data-id="element-129">
            Save Bank Details
          </motion.button>
        </form>
      </div>

      {/* Success Modal */}
      <AnimatePresence data-id="element-130">
        {showSuccess && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-[#0A0E1A]/90 backdrop-blur-xl flex items-center justify-center z-50 px-5" data-id="element-131">
            <motion.div initial={{
          scale: 0.9,
          opacity: 0,
          y: 20
        }} animate={{
          scale: 1,
          opacity: 1,
          y: 0
        }} exit={{
          scale: 0.9,
          opacity: 0,
          y: 20
        }} className="glass-card border-white/[0.1] p-8 text-center max-w-sm w-full shadow-2xl" data-id="element-132">
              <motion.div initial={{
            scale: 0
          }} animate={{
            scale: 1
          }} transition={{
            delay: 0.2,
            type: 'spring',
            stiffness: 200
          }} className="w-20 h-20 rounded-full bg-[#00D68F]/10 flex items-center justify-center mx-auto mb-6" data-id="element-133">
                <CheckCircle className="w-10 h-10 text-[#00D68F]" style={{
              filter: 'drop-shadow(0 0 8px rgba(0,214,143,0.5))'
            }} data-id="element-134" />
              </motion.div>
              <h3 className="text-white text-2xl font-bold tracking-tight mb-2" data-id="element-135">
                Bank Linked!
              </h3>
              <p className="text-[#64748B]" data-id="element-136">
                Your bank details have been saved
              </p>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}